export default "__VITE_ASSET__BpA7djEL__"